module.exports = __webpack_public_path__ + "assets/img/LTC043.a8dd171a.png";